<template lang="pug">
.charts-wrapper
  Charts(
    v-for="(id, key) in q_ids"
    :key="key"
    :question_id="id"
    :stats="stats.filter(e => e.question_id === id)"
  )
</template>

<script>
import Charts from "@/components/Backend/Statistics/Types/Charts.vue";

export default {
  props: [
    "stats"
  ],

  components: {
    Charts,
  },

  computed: {
    q_ids () {
      return this.stats
        .map(e => e.question_id)
        .filter((value, index, array) => array.indexOf(value) === index)
    },
  },
};
</script>